"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationSet = exports.AgInputRecommendationCategory = exports.AgInputRecommendation = exports.MetricCategoryRecommendation = exports.FieldRecommendation = exports.RecommendationLevel = exports.Recommendation = exports.SampleRecommendation = exports.Sample = exports.AgInput = exports.MetricCategory = exports.TreeNodeRecommendations = exports.TreeNode = exports.RecommendationSample = exports.RecommendationsFeedback = void 0;
const GeoEntities_1 = require("@becrop/abstract/Models/GeoEntities");
const axios_1 = __importDefault(require("axios"));
const download_1 = require("@common/utils/download");
var RecommendationStatus;
(function (RecommendationStatus) {
    RecommendationStatus["HasRecommendations"] = "has_recommendations";
    RecommendationStatus["NoRecommendations"] = "no_recommendations";
    RecommendationStatus["PendingRetrieval"] = "pending_retrieval";
    RecommendationStatus["Failed"] = "failed";
})(RecommendationStatus || (RecommendationStatus = {}));
function curateLevel(raw) {
    let temp = Math.round(raw);
    if (temp === 0 && raw > 0)
        temp = 1;
    return temp;
}
class RecommendationsFeedback {
    constructor(obj) {
        this.brief = obj.brief || '-';
        this.message = obj.message || '-';
        this.set = obj.set || new RecommendationSet([]);
    }
}
exports.RecommendationsFeedback = RecommendationsFeedback;
class RecommendationSample {
    constructor(obj) {
        this.product = obj.product || new AgInput({});
        this.sample = obj.sample || new Sample({});
        this.category = obj.category || new MetricCategory({});
        this.level = obj.level || -1;
        this.polishLevel();
    }
    polishLevel() {
        this.level = curateLevel(this.level);
    }
}
exports.RecommendationSample = RecommendationSample;
class TreeNode {
    constructor(obj) {
        (this.name = obj.name || '#Node'), (this.slug = obj.slug || this.slugify(this.name));
        this.children = obj.children || new Array();
    }
    slugify(s) {
        return s
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(' ', '_');
    }
}
exports.TreeNode = TreeNode;
class TreeNodeRecommendations extends TreeNode {
    constructor(treeNodeObj, treeNodeRecObj) {
        super(treeNodeObj);
        this.level = treeNodeRecObj.level;
        this.polishLevel();
    }
    polishLevel() {
        this.level = curateLevel(this.level);
    }
}
exports.TreeNodeRecommendations = TreeNodeRecommendations;
class MetricCategory {
    constructor(obj) {
        this.label = obj.label || '#MetricCategory';
        this.short = obj.short || 'CAT';
    }
}
exports.MetricCategory = MetricCategory;
class AgInput {
    constructor(obj) {
        this.hierarchyOrder = obj.hierarchyOrder || -1;
        this.hierarchyDepth = obj.hierarchyDepth || 0;
        this.name = obj.name || '#AgInput';
        this.slug = obj.slug || 'ag_input';
        this.parentSlug = obj.parentSlug;
        this.avgLevel = obj.avgLevel;
    }
}
exports.AgInput = AgInput;
class Sample {
    constructor(obj) {
        this.id = obj.id || -1;
        this.code = obj.code || 'XXXXXX';
        this.coordinates = obj.coordinates || 'POINT(0 0)';
        this.metrics = new Array();
    }
    get lat() {
        // @return Latitude from coordinates
        return '';
    }
    get long() {
        // @return Longitude from coordinates
        return '';
    }
    findMetric(m) {
        return this.metrics.find((sm) => sm.code_name === m);
    }
    async downloadReportPDF(anonymize) {
        let url = `/data/results/report/pdf/${this.code}`;
        let name = this.code;
        if (anonymize) {
            url = `${url}?anonymize=true`;
            name = `sample_report`;
        }
        try {
            await axios_1.default
                .get(url, {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/pdf',
                },
            })
                .then((res) => {
                (0, download_1.downloadPDFWithDynamicName)(res, `${name}.pdf`);
            })
                .catch((error) => {
                console.log(error);
            });
        }
        catch (e) {
        }
    }
}
exports.Sample = Sample;
class SampleRecommendation extends Sample {
    constructor(sampleObj, sampleRecObj) {
        super(sampleObj);
        this.level = sampleRecObj.level || null;
        this.status =
            sampleRecObj.status || this.level === null ? RecommendationStatus.PendingRetrieval : RecommendationStatus.HasRecommendations;
        this.polishLevel();
    }
    polishLevel() {
        if (this.level)
            this.level = curateLevel(this.level);
    }
}
exports.SampleRecommendation = SampleRecommendation;
class Recommendation {
    constructor(obj) {
        this.product = obj.product || new AgInput({});
        this.samples = obj.samples || new Array();
        this.category = obj.category || new MetricCategory({});
        this.level = obj.level || null;
        this.polishLevel();
    }
    polishLevel() {
        this.level = curateLevel(this.level);
    }
}
exports.Recommendation = Recommendation;
class RecommendationLevel {
    constructor(obj) {
        this.raw = obj.raw || -1;
        this.value = obj.value || -1;
        this.curateLevel();
    }
    curateLevel() {
        let curatedLevel = Math.round(this.raw);
        if (curatedLevel === 0 && this.raw > 0)
            curatedLevel = 1;
        return curatedLevel;
    }
}
exports.RecommendationLevel = RecommendationLevel;
class FieldRecommendation extends GeoEntities_1.Field {
    constructor(fieldObj, recommendations) {
        super(fieldObj);
        this.recSet = new RecommendationSet(recommendations) || new RecommendationSet(new Array());
        this.recommendations = fieldObj.recommendations;
    }
    getRecommendationsByAgInput(slug) {
        return []; //this.recSet.curatedRecommendations.filter((r:Recommendation) => r.product.slug === slug)
    }
    getAgInputLevel(slug) {
        const recsWithAg = this.getRecommendationsByAgInput(slug);
        if (recsWithAg.length > 0) {
            let level = recsWithAg.reduce((accum, rec, i, temp) => {
                accum += rec.level;
                if (i === temp.length - 1) {
                    return Math.round(accum / temp.length);
                }
                else {
                    return accum;
                }
            }, 0);
            return level;
        }
        return 0;
    }
}
exports.FieldRecommendation = FieldRecommendation;
class MetricCategoryRecommendation extends MetricCategory {
    constructor(mcObj, mcRecObj) {
        super(mcObj);
        this.numAppearances = mcRecObj.numAppearances || -1;
        this.level = mcRecObj.level;
        this.polishLevel();
    }
    polishLevel() {
        this.level = curateLevel(this.level);
    }
}
exports.MetricCategoryRecommendation = MetricCategoryRecommendation;
class AgInputRecommendation extends AgInput {
    constructor(agObj, agRecObj) {
        super(agObj);
        this.numAppearances = agRecObj.numAppearances || -1;
        this.level = agRecObj.level;
        this.polishLevel();
    }
    polishLevel() {
        this.level = curateLevel(this.level);
    }
}
exports.AgInputRecommendation = AgInputRecommendation;
class AgInputRecommendationCategory extends AgInput {
    constructor(agObj, agMCRObj) {
        super(agObj);
        this.categories = agMCRObj.categories || new Array();
        this.level = agMCRObj.level || -1;
        this.calculateLevel();
        this.polishLevel();
    }
    calculateLevel() {
        this.level = this.categories.reduce((accum, cat, i, temp) => {
            accum += cat.level;
            if (i === temp.length - 1) {
                return accum / temp.length;
            }
            else {
                return accum;
            }
        }, 0);
    }
    polishLevel() {
        this.level = curateLevel(this.level);
    }
}
exports.AgInputRecommendationCategory = AgInputRecommendationCategory;
class RecommendationSet {
    constructor(rec) {
        // console.log('Creando Set');
        // console.log(rec)
        this.recommendations = rec || new Array();
        this.curatedRecommendations = new Array();
        this.curateRecommendations();
        // console.log(this.recommendations);
    }
    curateRecommendations() {
        if (this.recommendations.length > 0) {
            this.curatedRecommendations = this.recommendations
                .filter((rec) => rec.level !== null &&
                rec.samples.length > 0 &&
                rec.level > 0 &&
                rec.product.parentSlug !== null &&
                rec.product.hierarchyDepth === 2)
                .map((r) => r);
        }
    }
    get recommendationCategories() {
        /*
          @return: an array of Metric Categories that had triggered recommendations
          Map the recommendations array into an array of MetricCategories, remove duplicates
        */
        const categoriesFromRecommendations = this.curatedRecommendations.map((r) => r.category);
        return Array.from(new Set(categoriesFromRecommendations));
    }
    get recommendationCategoriesExpanded() {
        /*
          @return: an array of Metric Categories that had triggered recommendations
          along with the number of appearances and avg level
        */
        const categoriesExpanded = this.curatedRecommendations.reduce((accum, rec) => {
            const existingCategory = accum.find((mc) => mc.short === rec.category.short);
            if (existingCategory) {
                existingCategory.numAppearances++;
                existingCategory.level =
                    curateLevel((existingCategory.level * (existingCategory.numAppearances - 1) + rec.level) / existingCategory.numAppearances);
            }
            else {
                accum.push(new MetricCategoryRecommendation(rec.category, {
                    numAppearances: 1,
                    level: rec.level,
                }));
            }
            return accum;
        }, []);
        return categoriesExpanded;
    }
    get samplesWithRecommendations() {
        /*
          @return: an array of all the samples triggering recommendations, with no extra info
        */
        const samplesFromRecommendations = this.curatedRecommendations.map((r) => r.samples);
        return Array.from(new Set(samplesFromRecommendations.flat()));
    }
    get allRawAgInputs() {
        /*
          @return: an array listing all products recommended in the set, no matter the category
          along with the number of appearances and the avg level
        */
        const agInputExpanded = this.recommendations.reduce((accum, rec) => {
            const existingAgInput = accum.find((ag) => ag.slug === rec.product.slug);
            if (existingAgInput) {
                existingAgInput.numAppearances++;
                existingAgInput.level =
                    curateLevel((existingAgInput.level * (existingAgInput.numAppearances - 1) + rec.level) / existingAgInput.numAppearances);
            }
            else {
                accum.push(new AgInputRecommendation(rec.product, {
                    numAppearances: 1,
                    level: rec.level,
                }));
            }
            return accum;
        }, []);
        return agInputExpanded;
    }
    get allAgInputs() {
        /*
          @return: an array listing all products recommended in the set, no matter the category
          along with the number of appearances and the avg level
        */
        const agInputExpanded = this.curatedRecommendations.reduce((accum, rec) => {
            const existingAgInput = accum.find((ag) => ag.slug === rec.product.slug);
            if (existingAgInput) {
                existingAgInput.numAppearances++;
                existingAgInput.level =
                    curateLevel((existingAgInput.level * (existingAgInput.numAppearances - 1) + rec.level) / existingAgInput.numAppearances);
            }
            else {
                accum.push(new AgInputRecommendation(rec.product, {
                    numAppearances: 1,
                    level: rec.level,
                }));
            }
            return accum;
        }, []);
        return agInputExpanded;
    }
    get topAgInputs() {
        /*
          @return: same as above, but the list is sorted based on the level
        */
        return this.allAgInputs.sort((a, b) => b.level - a.level);
    }
    get topAgInputsAncestor() {
        /*
          @return: get the top recommended product along with its ancestors
        */
        const sortedAgInputs = this.topAgInputs;
        if (sortedAgInputs.length > 0)
            return this.findMyAncestors(sortedAgInputs[0].slug, true);
        return [];
    }
    get topAgInputsByCategory() {
        /*
          @return: get the list of recommended products each one with the categories related
        */
        const agInputExpanded = this.curatedRecommendations.reduce((accum, rec) => {
            const existingAgInput = accum.find((ag) => ag.slug === rec.product.slug);
            if (existingAgInput) {
                const existingCategoryIx = existingAgInput.categories.findIndex((c) => c.short === rec.category.short);
                if (existingCategoryIx !== -1) {
                    existingAgInput.categories[existingCategoryIx].numAppearances += 1;
                    existingAgInput.categories[existingCategoryIx].level =
                        curateLevel((existingAgInput.categories[existingCategoryIx].level + rec.level) /
                            existingAgInput.categories[existingCategoryIx].numAppearances);
                }
                else {
                    existingAgInput.categories.push(new MetricCategoryRecommendation(rec.category, {
                        level: rec.level,
                        numAppearances: 1,
                    }));
                }
                existingAgInput.calculateLevel();
            }
            else {
                accum.push(new AgInputRecommendationCategory(rec.product, {
                    categories: [new MetricCategoryRecommendation(rec.category, { level: rec.level, numAppearances: 1 })],
                    level: rec.level,
                }));
            }
            return accum;
        }, []);
        return agInputExpanded.sort((a, b) => b.level - a.level);
    }
    get fullTreeNode() {
        /*
          @return: build the full family tree of the products present in the recommendation set
        */
        const rootAgInputs = this.allRawAgInputs.filter((a) => a.parentSlug === null);
        if (rootAgInputs.length == 0)
            return new Array();
        const nodes = new Array();
        rootAgInputs.forEach((a) => {
            nodes.push(this.buildTreeNodeItem(a, false));
        });
        return nodes;
    }
    get fullCuratedTreeNode() {
        /*
          @return: build the full family tree of the products present in the recommendation set
        */
        const rootAgInputs = this.allAgInputs.filter((a) => a.parentSlug === null);
        if (rootAgInputs.length == 0)
            return new Array();
        const nodes = new Array();
        rootAgInputs.forEach((a) => {
            nodes.push(this.buildTreeNodeItem(a, true));
        });
        return nodes;
    }
    partialTreeNode(element, isCurated) {
        /*
          @return: build the family tree of an specific product
        */
        const nodes = new Array();
        nodes.push(this.buildTreeNodeItem(element, isCurated));
        return nodes;
    }
    buildTreeNodeItem(element, isCurated) {
        /*
          @return: the formatted treenode for an element
        */
        const children = this.findMyChildren(element.slug, isCurated);
        return new TreeNodeRecommendations({
            name: element.name,
            slug: element.slug,
            children: children.map((c) => this.buildTreeNodeItem(c, isCurated)),
        }, {
            level: element.level,
        });
    }
    findMyChildren(slug, isCurated) {
        /*
          @return: get the list of children of the specific product
        */
        const children = isCurated
            ? this.allRawAgInputs.filter((a) => a.parentSlug === slug)
            : this.allAgInputs.filter((a) => a.parentSlug === slug);
        return children;
    }
    findMyAncestors(slug, isCurated) {
        /*
          @return: get the list of ancestors of the specific product
        */
        const allAgInputs = isCurated ? this.allAgInputs : this.allRawAgInputs;
        const ag = allAgInputs.find((a) => a.slug === slug);
        if (!ag)
            return new Array();
        const parentSlug = ag.parentSlug;
        if (parentSlug === null) {
            return [ag];
        }
        else {
            const parentElement = allAgInputs.find((a) => a.slug === parentSlug);
            let ancestors = new Array();
            if (parentElement) {
                ancestors = this.findMyAncestors(parentElement.slug, isCurated);
            }
            return [ag, ...ancestors];
        }
    }
    isAgInputRecommended(slug) {
        /*
          @return: determine if a product is present in the recommendation set or not
        */
        if (this.topAgInputs.find((ag) => ag.slug === slug))
            return true;
        return false;
    }
    getAgInputRecommendation(slug) {
        return this.topAgInputs.find((ag) => ag.slug === slug);
    }
    hasRecommendationsForCategory(cat) {
        /*
          @return: determine if a category has recommendations or not
        */
        if (this.recommendationCategories.find((categ) => categ.short === cat))
            return true;
        return false;
    }
    hasRecommendationsForSample(sample) {
        /*
          @return: determine if a sample has recommendations or not
        */
        if (this.samplesWithRecommendations.find((s) => s.code === sample))
            return true;
        return false;
    }
    findRecommendationBySample(sample) {
        let recs = new Array();
        this.curatedRecommendations.forEach((r) => {
            const Ix = r.samples.findIndex((s) => s.code === sample);
            if (Ix !== -1) {
                recs.push(r);
            }
        });
        return recs;
    }
    showRecommendationsBySample(sample) {
        const sampleRecomms = new Array();
        this.curatedRecommendations.forEach((r) => {
            const Ix = r.samples.findIndex((s) => s.code === sample);
            if (Ix !== -1) {
                sampleRecomms.push(new RecommendationSample({
                    sample: r.samples[Ix],
                    product: r.product,
                    category: r.category,
                    level: r.level,
                }));
            }
        });
        return sampleRecomms;
    }
}
exports.RecommendationSet = RecommendationSet;
